const REAUTHENTICATION_EVENT = 'rado:reauthentication-required';

let pendingRequest = null;

export function requestReauthentication() {
  if (!pendingRequest) {
    pendingRequest = {};
    pendingRequest.promise = new Promise((resolve, reject) => {
      pendingRequest.resolve = resolve;
      pendingRequest.reject = reject;
    });
    window.dispatchEvent(new CustomEvent(REAUTHENTICATION_EVENT));
  }

  return pendingRequest.promise;
}

export function completeReauthentication() {
  pendingRequest?.resolve();
  pendingRequest = null;
}

export function cancelReauthentication() {
  const error = new Error('احراز مجدد توسط کاربر لغو شد.');
  error.code = 'identity.reauthentication.cancelled';
  pendingRequest?.reject(error);
  pendingRequest = null;
}

export function onReauthenticationRequired(handler) {
  window.addEventListener(REAUTHENTICATION_EVENT, handler);
  return () => window.removeEventListener(REAUTHENTICATION_EVENT, handler);
}
